import NetsuiteSourceIcon from "../../assets/components/sources/NetsuiteSourceIcon";

const NetsuiteLogomark = ({ height }: { height: number }) => {
  return <NetsuiteSourceIcon height={height} />;
};

export default NetsuiteLogomark;
